import { baseLoader } from './baseLoader';
import { getAllCalls } from 'src/services/getAllCalls';
import { getQueryParams } from 'src/utils/helpers/queryParams';
import { parseSort } from 'src/hooks/filters/useSort';
import { parseFilters } from 'src/hooks/filters/useFilters';

export const getCallsLoader = ({ request }) => {
	const { limit, page } = getQueryParams({ request }, ['page', 'limit']);
	const params = new URL(request.url).searchParams;

	return baseLoader(
		() =>
			getAllCalls({
				page: Number(page) || 1,
				limit: Number(limit) || 15,
				sort: parseSort(params),
				filters: parseFilters(params),
			}),
		'Failed to load all calls.',
		request,
	);
};
